// Add your custom JS here.
// Aggiungi un listener per lo scrolling
window.addEventListener("scroll", function() {
  // Ottieni l'altezza dell'header e della navbar
  var headerHeight = document.querySelector('header').offsetHeight;
  var navbarHeight = document.querySelector('#stick_nav').offsetHeight;

  // Verifica se la finestra è stata scrollata oltre l'altezza dell'header
  if (window.scrollY > headerHeight) {
	// Aggiungi la classe "sticky" alla navbar
	document.getElementById('stick_nav').classList.add('sticky_nav');
  } else {
	// Rimuovi la classe "sticky" dalla navbar
	document.getElementById('stick_nav').classList.remove('sticky_nav');
  }
});